import React, { useState, useEffect } from 'react';
import serviceBgIcon from 'assets/images/maintenance/service_bg_icon.png';
import checkboxIcon from 'assets/images/maintenance/Checkbox.png';

const STORAGE_KEY = 'maintenance_popup_dismissed';

function LineBreakText({ text }) {
  const lines = text.split('\n');
  return lines.map((line, i) => (
    <React.Fragment key={i}>
      {line}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

export default function MaintenancePopup({
  isActive = false,
  title = '',
  description = '',
  schedule = '',
  content = '',
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [dontShowToday, setDontShowToday] = useState(false);

  useEffect(() => {
    if (!isActive) return;
    const today = new Date().toISOString().split('T')[0];
    const dismissed = localStorage.getItem(`${STORAGE_KEY}_${today}`);
    if (!dismissed) {
      setIsVisible(true);
    }
  }, [isActive]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleCheckboxClose = () => {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem(`${STORAGE_KEY}_${today}`, 'Y');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="maintenance-popup-dimmed is-show" onClick={handleClose}>
      <div
        className="maintenance-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="maintenance-popup__close" onClick={handleClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <div
          className="maintenance-popup__header"
          style={{ backgroundImage: `url(${serviceBgIcon})` }}
        >
          <h1>
            <LineBreakText text={title} />
          </h1>
        </div>

        <div className="maintenance-popup__body">
          <p className="maintenance-popup__desc">
            <LineBreakText text={description} />
          </p>
          <div className="maintenance-popup__info">
            <div className="maintenance-popup__info-row">
              <span className="maintenance-popup__badge">일시</span>
              <p>
                <LineBreakText text={schedule} />
              </p>
            </div>
            <div className="maintenance-popup__info-row">
              <span className="maintenance-popup__badge">내용</span>
              <p>{content}</p>
            </div>
          </div>
        </div>

        <div className="maintenance-popup__footer">
          <div
            className="maintenance-popup__checkbox-wrap"
            onClick={handleCheckboxClose}
          >
            <span
              className="maintenance-popup__checkmark"
              style={{ backgroundImage: `url(${checkboxIcon})` }}
            />
            <span>오늘 하루 이 창을 열지 않음</span>
          </div>
        </div>
      </div>
    </div>
  );
}
